import defaultColor from "@/components/color";

export default {
    attribute: {
        decorationType: 'dv-decoration-1',
        color1: defaultColor[0], color2: defaultColor[1], text: '若比伤春意未多', textColor: '#ddd',
        isFiexd: false,
    },
}